module.exports = __webpack_public_path__ + "static/media/fullLogo.45ab2f89.png";